import store from '@/store.js'
import { TimelineMax, Linear, Back } from 'gsap'

export function lerp(start, end, amt) {
  return (1 - amt) * start + amt * end
}

export function invertColors(toggle) {
  document.documentElement.style.setProperty(
    '--c-txt',
    toggle ? '#fff' : store.state.colors.txt
  )
  document.documentElement.style.setProperty(
    '--c-bg',
    toggle ? store.state.colors.txt : store.state.colors.bg
  )
}

export function hoverEffect(nav) {
  var tl = null
  var hoverEffects = []
  var targetElement = document.querySelector('.word')
  var splitText = []

  if (targetElement && targetElement.hasChildNodes()) {
    let children = targetElement.childNodes
    for (let i = 0; i < children.length; i++) {
      splitText.push(children[i])
    }
  }

  function hover1() {
    tl = new TimelineMax({ repeat: -1 })
    tl.staggerTo(
      splitText,
      0.6,
      {
        y: -50,
        ease: Back.easeIn,
        repeat: -1,
        yoyo: true
      },
      ((1 / splitText.length) * 0.3).toFixed(2)
    )
  }

  function hover2() {
    tl = new TimelineMax({ repeat: -1, repeatDelay: 0 })
    tl.staggerTo(
      splitText,
      0.3,
      { y: -10, rotationX: -180, ease: Linear.easeNone, repeat: 1, yoyo: true },
      0.1
    )
  }

  function hover3() {
    tl = new TimelineMax({ repeat: -1, repeatDelay: 0 })
    tl.staggerTo(
      splitText,
      0.3,
      { rotationY: 360, ease: Linear.easeNone, overwrite: false },
      0.1
    )
  }

  function hover4() {
    tl = new TimelineMax({ repeat: -1, repeatDelay: 0 })
    tl.staggerTo(
      splitText,
      0.3,
      {
        rotationY: 180,
        ease: Linear.easeNone,
        repeat: -1,
        repeatDelay: 1,
        yoyo: true
      },
      0
    )
  }

  function hover5() {
    tl = new TimelineMax({ repeat: -1, repeatDelay: 0 })
    tl.staggerTo(
      splitText,
      0.3,
      { y: 10, rotationY: 360, ease: Linear.easeNone, repeat: 1, yoyo: true },
      0.1
    )
  }

  if (nav) {
    hoverEffects.push(hover2, hover3, hover4, hover5)
  } else {
    hoverEffects.push(hover1, hover2, hover3, hover4, hover5)
  }

  var i = Math.floor(Math.random() * hoverEffects.length + 0)

  return hoverEffects[i]()
}
